'use client';

import { Icons } from '@/components/Shares/Icons';
import modalStyle from '@/components/Shares/Modal.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Flex, Group, Image, Modal, Stack, Text, Title } from '@mantine/core';
import { CouponsDiscount } from './CouponsDiscount';
import { CouponsTokenGift } from './CouponsTokenGift';
export const CouponsModal: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  const {
    i18n
  } = useLingui();
  const randomGift = Math.floor(Math.random() * 2);
  return <Modal opened={openModal === MODAL.COUPONS} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={modalStyle}>
      <Group pos="absolute" bottom={0} left={0} right={0} justify="center">
        <Image src="/assets/bottom-character.svg" alt="character" w={{
        base: 256,
        md: 350,
        lg: 357
      }} h={{
        base: 182,
        md: 250,
        lg: 254
      }} />
      </Group>
      <Flex justify="center" w="100%">
        <Flex direction="column" w={{
        base: '100%',
        sm: 523,
        lg: 465
      }} align="center" gap={{
        base: 92,
        sm: 110,
        lg: 98
      }} mx={{
        base: 31,
        sm: 28,
        lg: 20
      }}>
          <Stack align="center" gap={0}>
            <Title fz={{
            base: 28,
            sm: 36,
            lg: 32
          }} c="var(--text-prime)" className={gunterzBold.className}>
              {i18n._('Congratulations')}
            </Title>
            <Text fz={12} tt="uppercase" fw={700}>
              {i18n._('You’ve successfully redeemed your coupon.')}
            </Text>
          </Stack>

          {randomGift === 0 ? <CouponsDiscount /> : <CouponsTokenGift />}
        </Flex>
      </Flex>
    </Modal>;
};